export default "__VITE_ASSET__rFjJsxKA__"